import { render, staticRenderFns } from "./Paypal.vue?vue&type=template&id=3d091ddc&scoped=true&"
import script from "./Paypal.vue?vue&type=script&lang=js&"
export * from "./Paypal.vue?vue&type=script&lang=js&"
import style0 from "./Paypal.vue?vue&type=style&index=0&id=3d091ddc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d091ddc",
  null
  
)

export default component.exports